import { StyleSheet, Dimensions } from 'react-native';
import { PopupPosition } from './DbPopup.types';

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

// 导出 SCREEN_HEIGHT 供组件使用
export { SCREEN_HEIGHT, SCREEN_WIDTH };

/** 默认配置 */
export const POPUP_DEFAULTS = {
    overlayColor: '#000000',
    overlayOpacity: 0.5,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    duration: 300,
    closeIconSize: 22,
    closeIconColor: '#969799',
};

/** 获取位置相关样式 */
export const getPositionStyle = (
    position: PopupPosition,
    round: boolean,
    borderRadius: number,
    width?: number | string,
    height?: number | string,
    maxWidth?: number | string,
    maxHeight?: number | string,
) => {
    const baseStyle: any = {};
    const computedRadius = round ? borderRadius : 0;

    switch (position) {
        case 'center':
            baseStyle.alignSelf = 'center';
            baseStyle.borderRadius = computedRadius;
            baseStyle.maxWidth = maxWidth || SCREEN_WIDTH * 0.85;
            baseStyle.maxHeight = maxHeight || SCREEN_HEIGHT * 0.8;
            break;
        case 'top':
            baseStyle.width = '100%';
            baseStyle.borderBottomLeftRadius = computedRadius;
            baseStyle.borderBottomRightRadius = computedRadius;
            if (height) baseStyle.height = height;
            if (maxHeight) baseStyle.maxHeight = maxHeight;
            break;
        case 'bottom':
            baseStyle.width = '100%';
            baseStyle.borderTopLeftRadius = computedRadius;
            baseStyle.borderTopRightRadius = computedRadius;
            if (height) baseStyle.height = height;
            if (maxHeight) baseStyle.maxHeight = maxHeight;
            break;
        case 'left':
            baseStyle.height = '100%';
            baseStyle.borderTopRightRadius = computedRadius;
            baseStyle.borderBottomRightRadius = computedRadius;
            baseStyle.width = width || SCREEN_WIDTH * 0.8;
            if (maxWidth) baseStyle.maxWidth = maxWidth;
            break;
        case 'right':
            baseStyle.height = '100%';
            baseStyle.borderTopLeftRadius = computedRadius;
            baseStyle.borderBottomLeftRadius = computedRadius;
            baseStyle.width = width || SCREEN_WIDTH * 0.8;
            if (maxWidth) baseStyle.maxWidth = maxWidth;
            break;
    }

    return baseStyle;
};

/** 获取容器对齐方式 */
export const getContainerAlignment = (position: PopupPosition) => {
    switch (position) {
        case 'center':
            return { justifyContent: 'center' as const, alignItems: 'center' as const };
        case 'top':
            return { justifyContent: 'flex-start' as const, alignItems: 'stretch' as const };
        case 'bottom':
            return { justifyContent: 'flex-end' as const, alignItems: 'stretch' as const };
        case 'left':
            return { justifyContent: 'center' as const, alignItems: 'flex-start' as const };
        case 'right':
            return { justifyContent: 'center' as const, alignItems: 'flex-end' as const };
        default:
            return { justifyContent: 'center' as const, alignItems: 'center' as const };
    }
};

/** 获取动画初始值 */
export const getAnimationInitialValue = (position: PopupPosition) => {
    switch (position) {
        case 'center':
            return { opacity: 0, scale: 0.9 };
        case 'top':
            return { translateY: -300 };
        case 'bottom':
            return { translateY: 300 };
        case 'left':
            return { translateX: -300 };
        case 'right':
            return { translateX: 300 };
        default:
            return { opacity: 0 };
    }
};

/** 创建样式 */
export const createStyles = () => {
    return StyleSheet.create({
        // Modal 容器
        modalContainer: {
            flex: 1,
        },
        // 遮罩层
        overlay: {
            ...StyleSheet.absoluteFillObject,
        },
        // 弹出层容器
        popupContainer: {
            backgroundColor: POPUP_DEFAULTS.backgroundColor,
            overflow: 'hidden',
        },
        // 头部
        header: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingHorizontal: 16,
            paddingVertical: 14,
            borderBottomWidth: StyleSheet.hairlineWidth,
            borderBottomColor: '#EBEDF0',
        },
        headerTitle: {
            fontSize: 16,
            fontWeight: '600',
            color: '#323233',
            textAlign: 'center',
        },
        // 关闭按钮
        closeButton: {
            position: 'absolute',
            padding: 8,
            zIndex: 10,
        },
        closeButtonTopLeft: {
            top: 8,
            left: 8,
        },
        closeButtonTopRight: {
            top: 8,
            right: 8,
        },
        closeButtonBottomLeft: {
            bottom: 8,
            left: 8,
        },
        closeButtonBottomRight: {
            bottom: 8,
            right: 8,
        },
        // 内容区域
        content: {
            flexGrow: 1,
        },
        contentScrollable: {
            flexGrow: 1,
        },
        // 底部
        footer: {
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderTopWidth: StyleSheet.hairlineWidth,
            borderTopColor: '#EBEDF0',
        },
    });
};
